export enum RenderModalSize {
  Small = 'small',
  Middle = 'middle',
  Large = 'large',
  Giant = 'giant',
}
